<template>
  <div
    class="calico-select-card"
    @click="selectCard"
  >
    <div
      class="container"
      :class="{
        active: value === modelValue,
        disabled,
      }"
    >
      <div
        class="content"
        :class="{ disabled }"
      >
        <h3 class="heading--xsmall">
          {{ title }}
        </h3>
        <p class="body--medium">
          {{ description }}
        </p>
      </div>
      <div v-if="value === modelValue">
        <i class="bi bi-check-circle-fill" />
      </div>
      <div v-else>
        <i class="bi bi-circle" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CalicoSelectCard",
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    modelValue: {
      type: [String, Number],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: ""
    },
  },
  methods: {
    selectCard() {
      if (!this.disabled && this.value !== this.modelValue) {
        this.$emit("update:modelValue", this.value);
      }
    }
  },
};
</script>

<style lang="scss">
.calico-select-card {
  .container {
    @include inline-space($space-small);
    @include inset-space($space-medium);
    justify-content: space-between;
    border: 1px solid $color-neutral-light;
    border-radius: $radius-large;
    color: $color-black;
    cursor: pointer;

    &:hover:not(.disabled) {
      background-color: $color-neutral-lightest;
      border-color: $color-neutral-light;
    }

    .content {
      @include stack-space($space-small);
      h3, p {
        margin: 0;
      }
    }

    .bi-check-circle-fill {
      font-size: $icon-small;
      color: $color-green-dark;
    }

    .bi-circle {
      font-size: $icon-small;
      color: $color-neutral-light;
    }
  }

  .active {
    background-color: $color-green-lightest;
    border-color: $color-green-dark;
  }

  .disabled {
    background-color: $color-neutral-light;
    border-color: $color-neutral-light;
    color: $color-neutral-dark;
    cursor: not-allowed;
  }
}
</style>